import { render, staticRenderFns } from "./SearchResultNoData.vue?vue&type=template&id=c043bf74&scoped=true&"
var script = {}
import style0 from "./SearchResultNoData.vue?vue&type=style&index=0&id=c043bf74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c043bf74",
  null
  
)

export default component.exports